// src/shared/services/LocalService.js
import RealService from './RealService';
import apiService from './apiService';
import { ServiceError, ErrorTypes } from './types';

class LocalService extends RealService {
    // Override refreshTokens to do nothing in local mode
    async refreshTokens() {
        // Local auth doesn't use Cognito token refresh
        throw new Error('Token refresh not available in local mode');
    }

    // Auth methods
    async getCurrentUser() {
        const accessToken = localStorage.getItem('AccessToken');
        if (!accessToken) {
            return null;
        }
        try {
            console.log('Using LOCAL to fetch user data')
            const UserResult = await apiService.get('/cognito/userdetails', {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            return UserResult;

        } catch (error) {
            if (error.response?.status === 401 || error.type === 'AUTH') {
                localStorage.removeItem('IdToken');
                localStorage.removeItem('AccessToken');
                this.currentUser = null;
                return null;
            }

            if (error.response?.status === 404) {
                throw new ServiceError(
                    ErrorTypes.NOT_FOUND,
                    'User not found'
                );
            }

            throw new ServiceError(
                ErrorTypes.SERVER,
                error.response?.data?.message || 'Failed to fetch user data'
            );
        }
    }

    async login(credentials) {
        try {
            const username = credentials.email
            const password = credentials.password
            console.log('LocalService.login called with:', username);

            const response = await apiService.post(
                '/cognito/login',
                { username, password }
            );

            console.log('LocalService.login response:', response);

            if (response && response.AuthenticationResult) {
                return response.AuthenticationResult;
            }

            throw new ServiceError(
                ErrorTypes.AUTH,
                'Invalid login response from server'
            );
        } catch (error) {
            console.error('LocalService.login error:', error);
            throw error;
        }
    }
}

export default LocalService;
